var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.printData.requestOwnerInfo || {}).requestCode)?_c('div',[(_vm.printData.requestOwnerInfo)?_c('row',[_c('column',{attrs:{"full-width":""}},[_c('block',[_c('papers-table',{attrs:{"headers":[
            {
              value: 'requestCode',
              text: 'رقم الطلب',
            },
            {
              value: 'requesterName',
              text: 'مقدم الطلب',
            },
            {
              value: 'socialId',
              text: 'رقم الهوية',
            },
            {
              value: 'requestDate',
              text: 'تاريخ الطلب',
            } ],"items":[_vm.printData.requestOwnerInfo]}})],1)],1)],1):_vm._e(),(_vm.printData.prosecutorRequestParties)?_c('row',[_c('column',{attrs:{"full-width":""}},[_c('block',{attrs:{"title":"بيانات المدعين"}},[_c('papers-table',{attrs:{"headers":[
            {
              value: 'partyType',
              text: 'النوع',
            },
            {
              value: 'partyName',
              text: 'الاسم',
            },
            {
              value: 'socialId',
              text: 'رقم الإثبات',
            },
            {
              value: 'representativeName',
              text: 'اسم الممثل',
            } ],"items":_vm.printData.prosecutorRequestParties}})],1)],1)],1):_vm._e(),(_vm.printData.defendantRequestParties)?_c('row',[_c('column',{attrs:{"full-width":""}},[_c('block',{attrs:{"title":"بيانات المدعى عليهم"}},[_c('papers-table',{attrs:{"headers":[
            {
              value: 'partyType',
              text: 'النوع',
            },
            {
              value: 'partyName',
              text: 'الاسم',
            },
            {
              value: 'socialId',
              text: 'رقم الإثبات',
            },
            {
              value: 'representativeName',
              text: 'اسم الممثل',
            } ],"items":_vm.printData.defendantRequestParties}})],1)],1)],1):_vm._e(),(_vm.printData.caseInfo)?_c('row',[_c('column',{attrs:{"full-width":""}},[_c('block',{attrs:{"title":"بيانات الدعوى"}},[_c('papers-table',{attrs:{"vertical":"","headers":[
            {
              value: 'caseTypeName',
              text: 'نوع الدعوى',
            },
            {
              value: 'subject',
              text: 'موضوع الدعوى',
            },
            {
              value: 'demands',
              text: 'الطلبات',
            },
            {
              value: 'proofs',
              text: 'الأسانيد',
            } ],"items":[_vm.printData.caseInfo]}})],1)],1)],1):_vm._e()],1):_c('div',{staticClass:"status-box"},[_c('div',{staticClass:"status-line"},[_c('v-icon',{staticStyle:{"font-size":"45px","margin-left":"10px"},attrs:{"color":"primary"}},[_vm._v(" mdi-information ")]),_c('div',{staticClass:"text-green-600 text-lg font-bold",staticStyle:{"font-size":"32px"},domProps:{"innerHTML":_vm._s(_vm.message)}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }